import { render, staticRenderFns } from "./natResourcesMain.vue?vue&type=template&id=5dcef36c&scoped=true&"
import script from "./natResourcesMain.vue?vue&type=script&lang=js&"
export * from "./natResourcesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcef36c",
  null
  
)

export default component.exports